var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2hlbHBlcnMvY2FtZWxDYXNlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL3NyYy9oZWxwZXJzL2NhbWVsQ2FzZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxXQUFBLEdBQWMsU0FBQyxDQUFEO0FBQ1osTUFBQTtFQUFBLElBQXdDLENBQUksQ0FBNUM7QUFBQSxVQUFVLElBQUEsS0FBQSxDQUFNLG9CQUFOLEVBQVY7O0VBQ0EsSUFBQSxHQUFPLFNBQUMsQ0FBRDtXQUFPLENBQUMsQ0FBQyxNQUFGLENBQUEsQ0FBVSxDQUFDLFdBQVgsQ0FBQSxDQUFBLEdBQTJCLENBQUMsQ0FBQyxLQUFGLENBQVEsQ0FBUjtFQUFsQztTQUNQLENBQUMsQ0FBQyxLQUFGLENBQVEsYUFBUixDQUFzQixDQUFDLEdBQXZCLENBQTJCLElBQTNCLENBQWdDLENBQUMsSUFBakMsQ0FBc0MsRUFBdEM7QUFIWTs7QUFLZCxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNmLGFBQUEsV0FEZSJ9
